<div class="actionConfrimModal">
  <p-dialog [(visible)]="displayConfirmReplay" [header]="modalTitle" (onHide)="closeComponent()"
            [draggable]="false"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false">

    <div class="grid numberOfImpactedFolds">
      <div class="col-12 right">
        <p>{{ 'FOLD.ACTION_COMPONENT.ACTION_CONFIRM_IMPACTED' | translate }}: {{numberOfConcernedFold}}*</p>
      </div>
    </div>
    <div class="grid kindOfAction" *ngIf="kindOfActionConfirm !== 3 && kindOfActionConfirm !== 4">
      <div class="col-12 center">
        <p-selectButton [options]="actions" [(ngModel)]="selectedAction"
                        (ngModelChange)="getNumberOfConcernerdFolds()"></p-selectButton>
      </div>
    </div>

    <div class="grid" *ngIf="kindOfActionConfirm === 3">
      <div class="col-5">
      <h3>{{ 'UPLOAD_COMPONENT.PLANNED_DATE_LABEL' | translate }}</h3>
      </div>
      <div class="col-7">
        <p-calendar [(ngModel)]="delayedSendDate" [dateFormat]="'dd/mm/yy'"
                    [appendTo]="'body'"
                    [selectionMode]="'single'"
                    [readonlyInput]="true"
                    [showButtonBar]="true"
                    [showIcon]="true" [minDate]="minDelayedSendDate"
                    [maxDate]="maxDelayedSendDate"></p-calendar>
      </div>
    </div>


    <div class="grid">
      <h3>{{ 'FOLD.ACTION_COMPONENT.ACTION_CONFIRM_REASONS' | translate }}</h3>
    </div>
    <div class="grid">
      <textarea pInputTextarea [(ngModel)]="justification" rows="10" cols="50"></textarea>
    </div>


    <div class="col-12 center buttonSpecific">
      <button [disabled]="numberOfConcernedFold===0" pButton type="button" (click)="processRequest()"
              [label]="buttonLabel" class="p-button-success"></button>
    </div>
    <div style="color: #6d071a" *ngIf="kindOfActionConfirm === 3 || kindOfActionConfirm === 4" class="uig-12 kindOfAction"><h3>*{{'COMMON.WARN_ALL_DEPOSIT_IMPACTED' | translate }}</h3></div>
  </p-dialog>
</div>


